import { Component, OnInit } from '@angular/core';
import { DashboardSectionStatus } from '../dashboard.component';
import { ZenplansTestDataProviderService } from './../../services/zenplans-test-data-provider.service';
//import countries from '../../assets/data/countries.json';
import plantree from '../../../assets/data/plan-tree.json';

@Component({
  selector: 'app-my-dashboard-tab2',
  templateUrl: './my-dashboard-tab2.component.html',
  styleUrls: ['./my-dashboard-tab2.component.scss']
})
export class MyDashboardTab2Component implements OnInit {
  SectionStatus = DashboardSectionStatus
  SectionTitle = "My Debts"
  DebtsInfo = 'John, why no take a few minutes to review the items value listed in your plan?'

  DebtsNumbers = [
    {
      circle: 'upToDate',
      number: 4,
      SectionStatus: DashboardSectionStatus[0]
    },
    {
      circle: 'toReview',
      number: 7,
      SectionStatus: DashboardSectionStatus[1]
    },
    {
      circle: 'toAdd',
      number: 12,
      SectionStatus: DashboardSectionStatus[2]
    },
  ]

  reviewStatusPerSection = [];
  constructor(private zenPlansData:ZenplansTestDataProviderService) { 
  }

  async ngOnInit() {
    let sectionStatus = await this.zenPlansData.getPlanCategoryStatus("my debts");
    this.DebtsNumbers[0].number= sectionStatus["upToDates"];
    this.DebtsNumbers[1].number= sectionStatus["forReviews"];
    this.DebtsNumbers[2].number= sectionStatus["missing"];
    this.reviewStatusPerSection = sectionStatus["reviewCodes"];
  }

  

}
